import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../../../shared/src/lib/service/authentification.service';

@Component({
  selector: 'app-ponctual-availibility',
  templateUrl: './ponctual-availibility.component.html',
  styleUrls: ['./ponctual-availibility.component.scss']
})
export class PonctualAvailibilityComponent implements OnInit {
  teacherId: number;
  calendarId: number;
  calendarUnavailabilityId: number;
  calendarUrl: number;
  calendarUnavailabilityUrl: number;
  teacher;

  timezoneExplanation: boolean = false;

  constructor(
    private authenticationService: AuthenticationService){}

  ngOnInit() {
    this.authenticationService.currentUserSubject.subscribe(_current_user => {
      if (_current_user) {
        if (_current_user.user.timezone != 'Europe/Paris') {
          this.timezoneExplanation = true;
        }
        this.calendarId = this.authenticationService.extractIdFromUrl(_current_user.calendar);
        this.calendarUnavailabilityId = this.authenticationService.extractIdFromUrl(_current_user.unavaibility_calendar);
        this.calendarUrl = _current_user.calendar;
        this.calendarUnavailabilityUrl = _current_user.unavaibility_calendar;
        this.teacherId = _current_user.id;
        this.teacher = _current_user;
      }
    })
  }

}
